
/**
 * Created by nijin on 22/6/17.
 */
import {Component, OnInit, OnDestroy, ViewChild, Input} from '@angular/core';
import {WizardBaseContentComponent} from "../../../things/shared/wizard/wiz-base.component";
import {GlobalService} from "../../../global/global.service";
import {Subscription} from "rxjs";
import {SchemaService} from "../../schema.service";
import {AppModalComponent} from "../../../shared/modal/modal";
import {SaveSchemaModal} from "../../shared/modal/save.schema.modal";
import {EditAttributeComponent} from "../edit-attribute.component";

@Component({
    selector: 'nuc-schema-landing',
    templateUrl: './schema-edit-landing.html',
    styleUrls:['./schema.edit.scss']
})
export class SchemaEditLanding extends WizardBaseContentComponent implements OnInit, OnDestroy {

   public selectedTabTitle: string = '';
   public isInstructionVisible = true;
   public attributeDataType: Array<any> = [];
   public isLoading;
   eventData = {};
   previewSchema = {};
   schemaModel: any = {schema : {
    attributes:[],
    location:[]
    },
      isEdited:false
    };
  public selectedSchema: Subscription;

  private schemaCopy: any;

  @ViewChild('warning') warning: AppModalComponent;
  @ViewChild('savePopup') savePopup: SaveSchemaModal;
  @ViewChild('preview') previewPopup;
  @ViewChild('editAttribute') editAttribute: EditAttributeComponent;

  @Input() isMobileApp: boolean;

   constructor(private globalService: GlobalService,
               private schemaService: SchemaService) {
      super();
    }

    ngOnInit() {
     this.getAttributeDataType();
      this.selectedSchema = this.schemaService.getSelectedSchema().
      subscribe((schemaModel) => {
        this.schemaModel = schemaModel;
        this.schemaCopy = JSON.stringify(this.schemaModel.schema);
      } );

      if(SchemaService.getNotifierPreference()){
        this.isInstructionVisible = false;
      }
    }

    ngOnDestroy(){
     this.selectedSchema.unsubscribe();
    }

    tabChanged(title){
      this.selectedTabTitle = title;

    }

    hideInstruction(neverShow){
      this.isInstructionVisible = false;
      if(neverShow){
        SchemaService.setNotifierPreference();
      }
    }

  getAttributeDataType(){
    this.globalService.getConfigDataByType(this.globalService.ATTRIBUTE_DATA_TYPE)
      .subscribe((response)=>{ this.attributeDataType = response.items}, ()=>{})
  }

  canMoveForward(): boolean{
    return this.schemaModel.schema.attributes.length &&
      this.schemaModel.schema.location.length;
  }

  onValidState(subject, nextStep){
    this.editAttribute.discardAllChanges();
    if(this.schemaService.isCustomSchema(this.schemaModel.schema) && !this.isEdited()){
      if(subject)
        subject.next(nextStep);
      return;
    }

    this.savePopup.open(subject, nextStep);

  }

  onInvalidState(){
    this.warning.open();
  }

  isEdited() {
    return this.schemaCopy !== JSON.stringify(this.schemaModel.schema);
  }

  preview() {
    if(this.schemaService.getThingToken())
    {
      this.previewSchema = this.schemaService.getSchemaDataForPreview(this.schemaModel.schema);
      this.eventData = {};
      this.eventData = this.schemaService.getEventData({thing:null, schema:this.schemaModel.schema});
      this.previewPopup.open();
      return;
    }
    this.isLoading = true;
    this.schemaService.generateThingToken()
      .subscribe(() => {
          this.isLoading = false;
          this.previewSchema = this.schemaService.getSchemaDataForPreview(this.schemaModel.schema);
          this.eventData = this.schemaService.getEventData({thing: null, schema: this.schemaModel.schema});
          this.previewPopup.open();
        },
        () => {this.isLoading =false;})

  }



}




// WEBPACK FOOTER //
// ./src/app/schema/edit-schema/location/schema-edit-landing.component.ts